import { APP_ROUTER_BASENAME } from "adminui/src/app/app-routes";
import { useAppRootRoute } from "utils/hooks/use-app-route-root";

/*  Note:  There is a copy of this in  admin-portal/src/hooks/use-admin-ui-route.
    Noah said to make a copy for now and  he will refactor later.   Oct-11-2024
*/

export const useAdminUIRootRoute = () => {
  return useAppRootRoute(APP_ROUTER_BASENAME, 3002);
};
